import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-participatie-campagne',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconParticipatieCampagne {

  render() {
    return (
      <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="M11.99 24H5.21l2.58 8.3a1 1 0 0 0 .96.7h4.85c.68 0 1.16-.67.95-1.31L12 24Z"/>
  <path d="M16 10H3c-.55 0-1 .45-1 1v2H1c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h1v2c0 .55.45 1 1 1h13l12.78 6.88c.15.08.31.12.47.12H30c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1h-.74a.94.94 0 0 0-.47.12zm0 10H4v-8h12zm17-8v7.72c1.72-.45 3-2 3-3.86s-1.28-3.41-3-3.86"/>
</svg>

    );
  }
}
